<template>
  <VContainer fluid class="pa-0" style="position: sticky; top: 54px; z-index: 2;">
    <TransitionOverlay
      :display="highlightDemo"
      :overlay-right="false"
      pink
      name="slide-x-left"
      class="py-3 pl-4 pr-8"
      data-testid="demo-highlight"
    >
      <VRow no-gutters class="text-white">
        <VCol cols="auto">
          <DemonstratorAvatar
            :demonstrator="shoppingWith"
            :size="36"
            class="font16"
            style="border:2px solid; border-color: white;"
          />
        </VCol>
        <VCol>
          <VRow
            class="pl-4 text-left"
            no-gutters
          >
            <VCol class="text-none text-capitalize font12">
              <span>{{ $i18n.t("demonstrator.label.shoppingWith") }}:</span>
            </VCol>
          </VRow>
          <VRow no-gutters class="pl-4 mt-0 text-left">
            <VCol class="text-underline text-uppercase font-weight-medium" data-testid="name">
              {{ demonstratorName }}
            </VCol>
          </VRow>
        </VCol>
      </VRow>
    </TransitionOverlay>
  </VContainer>
</template>

<script setup lang="ts">
import DemonstratorAvatar from '~/components/account/demonstrator/DemonstratorAvatar.vue'
import TransitionOverlay from '~/components/base/TransitionOverlay.vue'
import { useCartStore } from '~/stores/cart'
import { usePersistentStore } from '~/stores/persistent'

const { $i18n } = useNuxtApp()
const cartStore = useCartStore()
const shoppingWith = computed(() => cartStore.demonstrator)
const persistentStore = usePersistentStore()
const persistentHighlightDemo = computed(() => persistentStore.getPersistentValue('highlightDemo'))

const highlightDemo = ref(false)

watch(persistentHighlightDemo, () => {
  highlightDemo.value = persistentHighlightDemo.value ?? false
})

const demonstratorName = computed((): string => {
  if (!shoppingWith.value) {
    return ''
  }
  return `${shoppingWith.value.firstName} ${shoppingWith.value.lastName}`
})

onMounted(() => {
  if (persistentHighlightDemo.value) {
    setTimeout(() => {
      highlightDemo.value = true
    }, 300)
    setTimeout(() => {
      persistentStore.updateValue('highlightDemo', false)
      highlightDemo.value = false
    }, 3000)
  }
})
</script>
